<footer class="footer">
    <div *ngIf="isPrimaryFooter" class="pt-5 pb-5 addBorderTop">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="footer__top">
                        <b class="colorPrimary">Cercacasa.it</b>
                        <h4>Trova i migliori professionisti dell’immobiliare e la casa ideale.</h4>
                        <p>Su Cercacasa.it trovi oltre 500.000 immobili da Agenzie certificate. Cerca tra gli annunci
                            immobiliari e scegli il professionista migliore che ti seguirà nel percorso di selezione e
                            trattativa.
                            Solo annunci sicuri da oltre 10.000 Agenti Immobiliari verificati.
                        </p>
                    </div>
                    <div class="footer__sezioni">
                        <ng-container *ngFor="let item of this.levelSezioni; let i = index">
                            <button class="cursor-pointer m-0 fw-500" [class.active]="i == this.indexSezioni"
                                (click)="this.selectSezione(i)">{{item}}</button>
                        </ng-container>
                    </div>
                    <div class="footer__tipologie" *ngIf="this.levelTipologie?.length !== 0">
                        <button class="cursor-pointer m-0 text-capitalize" [class.active]="this.indexTipologie == -1"
                            (click)="this.selectTipologie(-1)">Tutte</button>
                        <ng-container *ngFor="let item of this.levelTipologie; let i = index">
                            <button class="cursor-pointer m-0 text-capitalize" [class.active]="i == this.indexTipologie"
                                (click)="this.selectTipologie(i)">{{item.text}}</button>
                        </ng-container>
                    </div>
                    <div class="footer__zone">
                        <div class="row">
                            <div class="col-lg-3 col-md-6 col-sm-6 col-6" *ngFor="let col of this.levelProvince">
                                <a *ngFor="let item of col; let i = index" [href]="this.composeUrl(item)"
                                    target="_blank"><span>{{this.getSelectedData(item)}}</span> {{item.name}}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="footer__bottom pt-5 pb-5">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="footer__bottom--img pb-4">
                        <a [routerLink]="['/']" target="_blank">
                            <img [ngSrc]="'assets/img/logocercacasa.png'" alt="Logo Cercacasa.it PNG" width="200"
                                height="33">
                        </a>
                        <div class="iconContainer">
                            <a [routerLink]="['/chi-siamo']"> <i class="icon-question-circle" title="Chi siamo"></i></a>
                            <a href="https://www.facebook.com/cercacasa.it" rel="noreferrer" target="_blank"> <i
                                    class="icon-facebook-brands" title="Pagina Facebook"></i></a>
                        </div>
                    </div>
                    <div class="footer__bottom--links">
                        <a [routerLink]="['/chi-siamo']">Chi siamo</a>
                        <span class="ms-2 me-2">-</span>
                        <a [routerLink]="['/contattaci']">Contattaci</a>
                        <span class="ms-2 me-2">-</span>
                        <a [routerLink]="['/privacy-policy']">Privacy Policy</a>
                        <span class="ms-2 me-2">-</span>
                        <a [routerLink]="['/cookie-policy']">Cookie Policy</a>
                        <span class="ms-2 me-2">-</span>
                        <a [routerLink]="['/condizioni-uso']">Condizioni d'uso</a>
                    </div>
                    <p class="mt-4 mb-0">CERCACASA.IT - Società a Responsabilità Limitata</p>
                    <p class="mb-0">P.IVA 15887381000 / REA: RM 1620773</p>
                    <p class="mb-0">VIA SARDEGNA, 50 00187 ROMA (RM)</p>
                </div>
            </div>
        </div>
    </div>
</footer>
